//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// eslint-disable-next-line object-curly-newline
import { mdiMonitor, mdiTabletAndroid, mdiArrowUp, mdiArrowDown } from '@mdi/js'
import ChartjsComponentDoughnutChart from './charts-components/ChartjsComponentDoughnutChart.vue'
import chartjsData from './chartjsData'

export default {
  components: {
    ChartjsComponentDoughnutChart,
  },
  setup() {
    const stockData = [
      {
        device: 'Desktop',
        symbol: mdiMonitor,
        color: 'primary',
        percentage: 80,
        upDown: 2,
      },
      {
        device: 'Mobile',
        symbol: mdiTabletAndroid,
        color: 'warning',
        percentage: 10,
        upDown: 8,
      },
      {
        device: 'Tablet',
        symbol: mdiTabletAndroid,
        color: 'success',
        percentage: 10,
        upDown: -5,
      },
    ]

    return {
      chartjsData,
      mdiArrowUp,
      mdiArrowDown,
      stockData,
    }
  },
}
